import Rooms from "./Rooms";
import RoomsMenu from "./RoomsMenu";


export default function RoomsUI () {

    return (
        <div className='blockContainer '>
            <RoomsMenu/> 
            <Rooms/>
      </div>
      )
}